/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingUsageAggregationTrendRequest extends models.BillingAggregationBase {
    getFixupPrototypeFunction() { return BillingUsageAggregationTrendRequest.fixupPrototype; }

    static newInstance(model: Partial<BillingUsageAggregationTrendRequest>): BillingUsageAggregationTrendRequest {
        let obj = Object.assign(new BillingUsageAggregationTrendRequest(), model);
        BillingUsageAggregationTrendRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingUsageAggregationTrendRequest>): BillingUsageAggregationTrendRequest {
        if (!model) return null;
        return BillingUsageAggregationTrendRequest.newInstance(<BillingUsageAggregationTrendRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingUsageAggregationTrendRequest) {
        if (!obj) return;

        models.BillingUsageAggregationTrendRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingUsageAggregationTrendRequest): boolean {
        if (models.BillingAggregationBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingUsageAggregationTrendRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.granularity === undefined) {
            this.granularity = 0;
        }
        if (this.limit === undefined) {
            this.limit = 0;
        }
        if (this.group_by) {
            for (let val of this.group_by) {
                models.BillingGroupByDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * Number of seconds between steps
     */
    granularity: number;

    /**
     * If set, the dimensions to group results by
     */
    group_by: Array<models.BillingGroupByDetails>;

    /**
     * If set, limits the results to given number.
     */
    limit: number;

}
